module.exports = __webpack_public_path__ + "img/culture-1.2b2fad41.jpg";